<template>
  <KTCard :title="title" :subtitle="subTitle" :loading="loading">
    <template v-slot:body>
      <!-- fuente alta form -->
      <b-form class="form" @submit.prevent="onSubmit">
        <!-- codigo -->
        <b-form-group
          label="Código Fuente Alta *"
          label-for="codigo"
          description="Escriba el código"
        >
          <b-form-input
            id="codigo"
            v-model="fuenteAlta.id_fuente"
            type="text"
            required
            placeholder="Código Fuente Alta"
          ></b-form-input>
        </b-form-group>
        <!-- literal -->
        <b-form-group
          label="Literal Fuente Alta *"
          label-for="literal"
          description="Escriba el literal"
        >
          <b-form-input
            id="literal"
            v-model="fuenteAlta.descripcion"
            type="text"
            required
            placeholder="Literal Fuente Alta"
          ></b-form-input>
        </b-form-group>
        <div class="d-flex justify-content-end span-3">
          <b-button class="mr-2" @click="cancel()">Cancelar</b-button>
          <b-button type="submit" variant="primary">Guardar</b-button>
        </div>
      </b-form>
    </template>
  </KTCard>
</template>

<script>
import KTCard from "@/view/content/Card.vue";
import {
  ADD_FUENTE_ALTA,
  EDIT_FUENTE_ALTA
} from "@/core/services/store/fuenteAlta.module";
import ApiService from "@/core/services/api.service";

export default {
  name: "fuente-alta-add",
  components: {
    KTCard
  },
  data() {
    return {
      loading: false,
      fuenteAlta: {
        id_fuente: null,
        descripcion: ""
      }
    };
  },
  computed: {
    title() {
      return this.isEdit ? "Editar fuente alta" : "Nueva fuente alta";
    },
    subTitle() {
      return this.isEdit ? "Modifique los datos" : "Escriba todos los datos";
    },
    isEdit() {
      return this.$route.params.id !== undefined;
    }
  },
  async mounted() {
    if (this.isEdit) {
      this.loading = true;
      const resp = await ApiService.get(
        `dic_fuente_altas_modif?id_fuente=${this.$route.params.id}`
      );
      this.fuenteAlta = resp.data.result[0];
      this.loading = false;
    }
  },
  methods: {
    cancel() {
      this.loading = false;
      this.$router.push("/lists/fuente-alta");
    },
    onSubmit() {
      this.loading = true;
      if (this.isEdit) {
        this.$store.dispatch(EDIT_FUENTE_ALTA, this.fuenteAlta).then(() => {
          this.cancel();
        });
      } else {
        this.$store.dispatch(ADD_FUENTE_ALTA, this.fuenteAlta).then(() => {
          this.cancel();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/pages/users/add";
</style>
